import { useTranslation } from "react-i18next";
import { formatNumber } from "@/shared/utils/Numbers.tsx";

export default function useFormatNumber(): (
  value: number,
  decimals?: number,
) => string {
  const { t } = useTranslation(["common"]);
  return (value: number, decimals?: number) => formatNumber(t, value, decimals);
}
